// extracted by mini-css-extract-plugin
export default {"summaryContainer":"product_summaryContainer__18ELF","summaryContent":"product_summaryContent__9kMCJ","summaryLoadingOverlay":"product_summaryLoadingOverlay__0K6gO"};